module.exports = __webpack_public_path__ + "img/persona-fr.79b21468.png";